export default "__VITE_ASSET__6c6bc303__"